import { Link } from 'react-router-dom';
import { MediaContainer, MediaImgSection, MediaCard } from './media.styles';
import { Banner } from 'src/utilities/UILibrary/Media/Banner/Banner';

export default function Media() {
  return (
    <MediaContainer>
      <Banner imgSrc="https://finsphera-webapp-resources.s3.amazonaws.com/PresenciaMedios.png">
        <h1>Presencia en medios de comunicación</h1>
      </Banner>
      <MediaImgSection>
        <MediaCard>
          <figure>
            <img
              src="https://finsphera-webapp-resources.s3.amazonaws.com/img_media_new1.jpg"
              alt="noticias de Finsphera"
            />
          </figure>
          <Link
            to="https://www.eleconomista.com.mx/sectorfinanciero/FinSphera-la-fintech-numero-43-autorizada-buscara-el-financiamiento-sustentable-hacia-las-pymes-20221212-0068.html"
            target="_blank"
            rel="noreferrer"
          >
            Ver más
          </Link>
        </MediaCard>
        <MediaCard>
          <figure>
            <img
              src="https://finsphera-webapp-resources.s3.amazonaws.com/img_media_new2.jpeg"
              alt="noticias de Finsphera"
            />
          </figure>
          <Link
            to="https://www.bloomberglinea.com/2022/12/13/finsphera-se-une-al-club-de-fintechs-autorizadas-por-la-ley-para-operar-en-mexico/"
            target="_blank"
            rel="noreferrer"
          >
            Ver más
          </Link>
        </MediaCard>
        <MediaCard>
          <figure>
            <img
              src="https://finsphera-webapp-resources.s3.amazonaws.com/img_media_new3.jpg"
              alt="noticias de Finsphera"
            />
          </figure>
          <Link
            to="https://www.eleconomista.com.mx/sectorfinanciero/Fintech-ven-oportunidad-de-financiar-pymes-20221218-0037.html"
            target="_blank"
            rel="noreferrer"
          >
            Ver más
          </Link>
        </MediaCard>
      </MediaImgSection>
    </MediaContainer>
  );
}
